import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

const StyledPopup = styled("div")({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 9999,
});

const StyledPopupContent = styled("div")({
  backgroundColor: "#fff",
  padding: (theme) => theme.spacing(2),
  borderRadius: (theme) => theme.spacing(1),
  display: "flex",
  alignItems: "center",
  width: "150px",
  height: "50px",
});

const StyledPopupText = styled(Typography)({
  marginLeft: "15px",
});

const SubmittingPopup = ({title}) => {
  const { t } = useTranslation();

  return (
    <StyledPopup>
      <StyledPopupContent>
        <CircularProgress size={24} style={{ marginLeft: "10px" }} />
        <StyledPopupText variant="body1">{title? title:t("Submitting")}...</StyledPopupText>
      </StyledPopupContent>
    </StyledPopup>
  );
};

export default SubmittingPopup;
